/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-23 13:12:17
 **/

import { BaseServiceV2 } from "@/frameworks/libraries/restservice";

class DirectMessage extends BaseServiceV2 {
	constructor() {
		super();
	}

	private APIPath = (roomID?: string, path?: string) =>
		`/api/dm${roomID ? `/${roomID}` : ""}${path ? `/${path}` : ""}`;

	public list = {
		name: "directmessage:list",
		execute: (
			parameter: WebServices.DirectMessage.List.Request = {}
		): Promise<WebServices.DirectMessage.List.Response> => this.get(this.list.name, this.APIPath(), parameter)
	};

	public messages = {
		name: "directmessage:messages",
		execute: ({
			roomId,
			...parameter
		}: WebServices.Chat.Messages.Request): Promise<WebServices.Chat.Messages.Response> =>
			this.get(this.messages.name, this.APIPath(roomId, "messages"), parameter)
	};

	public addUsers = {
		name: "directmessage:addUsers",
		execute: ({
			roomId,
			...parameter
		}: WebServices.DirectMessage.AddUsers.Request): Promise<WebServices.DirectMessage.AddUsers.Response> =>
			this.post(this.addUsers.name, this.APIPath(roomId, "users"), parameter)
	};

	public create = {
		name: "directmessage:create",
		execute: (
			parameter: WebServices.DirectMessage.Create.Request
		): Promise<WebServices.DirectMessage.Create.Response> => this.post(this.create.name, this.APIPath(), parameter)
	};

	public sendMessage = {
		name: "directmessage:sendMessage",
		execute: ({
			roomId,
			...parameter
		}: WebServices.Chat.SendMessage.Request): Promise<WebServices.Chat.SendMessage.Response> =>
			this.post(this.sendMessage.name, this.APIPath(roomId, "messages"), parameter)
	};

	public checkDMExists = {
		name: "directmessage:dmexists",
		execute: (
			parameter: WebServices.DirectMessage.CheckDMExists.Request
		): Promise<WebServices.DirectMessage.CheckDMExists.Response> =>
			this.get(this.checkDMExists.name, this.APIPath(undefined, "dm_check"), parameter)
	};
}

export default class DirectMessageService {
	constructor(
		events: API.Events,
		public readonly dm = new DirectMessage()
	) {
		dm.set_event(events);
	}
}
